// @flow
import { RangosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    rango: {},
    listaRangos: [],
    loading: false,
    error: false,
    formSubmited: false,
};

type RangosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { rango?: {} | null, listaRangos?: [] | null, loading?: boolean, +value ?: boolean };

const Rangos = (state: State = INIT_STATE, action: RangosAction): any => {
    // console.log(action);
    switch (action.type) {
        case RangosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case RangosActionTypes.GET_RANGO: {
                    return {
                        ...state,
                        rango: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RangosActionTypes.LIST_RANGOS: {
                    return {
                        ...state,
                        listaRangos: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RangosActionTypes.ADD_RANGO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case RangosActionTypes.UPDATE_RANGO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case RangosActionTypes.UPDATE_RANGOS: {
                    return {
                        ...state,
                        listaRangos: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case RangosActionTypes.DELETE_RANGO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case RangosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case RangosActionTypes.GET_RANGO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        rango: {},
                        loading: false,
                    };
                }
                case RangosActionTypes.LIST_RANGOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaRangos: [],
                        loading: false,
                    };
                }
                case RangosActionTypes.ADD_RANGO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case RangosActionTypes.UPDATE_RANGO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case RangosActionTypes.DELETE_RANGO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case RangosActionTypes.GET_RANGO:
            return { ...state, error: false, loading: true };
        case RangosActionTypes.LIST_RANGOS:
            return { ...state, error: false, loading: true };
        case RangosActionTypes.ADD_RANGO:
            return { ...state, error: false, loading: true };
        case RangosActionTypes.UPDATE_RANGO:
            return { ...state, error: false, loading: true };
        case RangosActionTypes.DELETE_RANGO:
            return { ...state, error: false, loading: true };
        case RangosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                rango: {},
                listaRangos: [],
                formSubmited: false
            };
        case RangosActionTypes.RESET_SOFT:
            return {
                ...state,
                loading: false,
                error: false,
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Rangos;
